module.exports = __webpack_public_path__ + "img/join us.1f05ff53.png";